import { useState, useCallback } from "react";

const useDialog = () => {

	const [open, setOpen] = useState<boolean>(false);

	const handleShow = useCallback(() => {
		setOpen(true);
	}, []);
	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	return {
		open,
		handleShow,
		handleClose
	};
};

export default useDialog;